import { createFetcher } from '../../Common';

import { getBaseUrl, HR_REPORT_TABLE_COLUMNS_ID, HR_REPORTS_ENDPOINT } from '../../constants';

import { panelQueryBuilder } from '../panelReports/panelUtils';

import { columnMapping } from './hrUtils';

export class HRReports {
  static getInstance() {
    if (!this.instance) {
      this.instance = new HRReports(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = HR_REPORTS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllHRReports(req) {
    const queryString = panelQueryBuilder(req, columnMapping, HR_REPORT_TABLE_COLUMNS_ID);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async getHRReportById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}

export const createHRReports = () => HRReports.getInstance();
